import { skipToken, useQuery } from "@tanstack/react-query";
import { useCheckPermission } from "Hooks/usePermission";
import { getRaffleCurrent, Permission } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { AccessRightCodes } from "Models/AccessRightCodes";
import { MS_TIME } from "Utils/TimeUtils";

const RAFFLE_QUERY_KEY = "RAFFLE";

export const raffleKeys = {
  all: [RAFFLE_QUERY_KEY],
  current: () => [...raffleKeys.all, "current"],
  history: () => [...raffleKeys.all, "history"],
};

export const useRaffleCurrentQuery = () => {
  // The dashboard card mounts for every persona: without Raffle Read, skip the certain 403. A
  // skipped query stays isPending, which the card renders as nothing.
  const canRead = useCheckPermission(AccessRightCodes.Raffle, Permission.Read);

  return useQuery({
    queryKey: raffleKeys.current(),
    queryFn: canRead
      ? processResponseWithApiProblemDetails(() => getRaffleCurrent())
      : skipToken,
    staleTime: MS_TIME.minute,
  });
};
